import { useEffect, useContext } from 'react';
import { useAuth0 } from '@auth0/auth0-react';
import * as Sentry from '@sentry/react';
import { TenantConfigContext } from 'context/TenantConfigContext';

export function useSentryUser() {
  const { isAuthenticated, user } = useAuth0();
  const tenantConfig = useContext(TenantConfigContext);

  useEffect(() => {
    if (!isAuthenticated || !tenantConfig.accountNumber) {
      Sentry.setUser(null);
      return;
    }

    Sentry.setUser({
      id: `${tenantConfig.accountNumber}-${user?.sub ?? ''}`,
      email: user?.email,
      username: user?.name,
    });

    Sentry.setContext('tenant', {
      accountNumber: tenantConfig.accountNumber,
      name: tenantConfig.name,
      isAdminView: tenantConfig.isAdminView,
      isSuperAdmin: tenantConfig.isSuperAdmin,
      isSupportAdmin: tenantConfig.isSupportAdmin,
      testTenant: tenantConfig.testTenantFlag,
      currencyCode: tenantConfig.currencyCode,
      onboardingStatus: tenantConfig.onboardingStatus,
      featureFlags: tenantConfig.featureFlags,
    });
  }, [
    isAuthenticated,
    user?.sub,
    user?.email,
    user?.name,
    tenantConfig.accountNumber,
    tenantConfig.name,
    tenantConfig.isAdminView,
    tenantConfig.isSuperAdmin,
    tenantConfig.isSupportAdmin,
    tenantConfig.testTenantFlag,
    tenantConfig.currencyCode,
    tenantConfig.onboardingStatus,
    tenantConfig.featureFlags,
  ]);
}
